import React from 'react';
import { capitalizeOnlyFirstLetter } from 'corporate-utils';
import {
  IconContainerStyled,
  StarIconStyled,
  Subtitle,
  Title,
} from './SectionHeader.style';
import { Style } from '../../models/auto-generated-strapi-types/types/components/Style';

export interface SectionHeaderProps {
  subtitle: string;
  title: string;
  capitalizeTitle?: boolean;
  mainTitleFontSize?: number;
  titleFontSize?: number;
  mainTitleMobileFontSize?: number;
  titleMobileFontSize?: number;
  mainTitleFontWeight?: number;
  mainTitleMobileFontWeight?: number;
  titleFontWeight?: number;
  titleMobileFontWeight?: number;
  mainTitlePersonalization?: Style[];
  titlePersonalization?: Style[];
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  subtitle,
  title,
  capitalizeTitle = true,
  mainTitleFontSize,
  mainTitleMobileFontSize,
  titleFontSize,
  titleMobileFontSize,
  mainTitleFontWeight,
  mainTitleMobileFontWeight,
  titleFontWeight,
  titleMobileFontWeight,
  mainTitlePersonalization,
  titlePersonalization,
}) => {
  return (
    <div>
      {subtitle && (
        <IconContainerStyled>
          <StarIconStyled></StarIconStyled>
        </IconContainerStyled>
      )}
      {/* First title */}
      <Subtitle
        fontSize={mainTitleFontSize}
        fontMobileSize={mainTitleMobileFontSize}
        fontWeight={mainTitleFontWeight}
        fontMobileWeight={mainTitleMobileFontWeight}
        personalization={mainTitlePersonalization}
      >
        {subtitle}
      </Subtitle>
      {/* Second title */}
      <Title
        fontSize={titleFontSize}
        fontMobileSize={titleMobileFontSize}
        fontWeight={titleFontWeight}
        fontMobileWeight={titleMobileFontWeight}
        personalization={titlePersonalization}
      >
        {title && capitalizeTitle ? capitalizeOnlyFirstLetter(title) : title}
      </Title>
    </div>
  );
};

export default SectionHeader;
